import { styled } from '@mui/material'
import {
  Business as BaseBusiness,
  BusinessCenter as BaseBusinessCenter,
  Check as BaseCheck,
  Lock as BaseLock,
  Mail as BaseMail,
  Person as BasePerson
} from '@mui/icons-material'

export const BusinessIcon = styled(BaseBusiness)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.palette.brand.white};
    font-size: ${props => props.size};
  }
`

export const CheckIcon = styled(BaseCheck)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.palette.brand.white};
    font-size: ${props => props.size};
  }
`

export const FileSignIcon = styled('img')`
  width: ${props => props.size};
`

export const LockIcon = styled(BaseLock)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.palette.brand.white};
    font-size: ${props => props.size};
  }
`

export const MailIcon = styled(BaseMail)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.palette.brand.white};
    font-size: ${props => props.size};
  }
`

export const PersonIcon = styled(BasePerson)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.palette.brand.white};
    font-size: ${props => props.size};
  }
`

export const ProfileIcon = styled('img')`
  width: ${props => props.size};
`
